import type { AxiosResponse } from 'axios';
import { injectable, injectFromBase } from 'inversify';
import { CurrentClientUserApiRoute } from '@client/entity/current-client-user/data/constant/current-client-user.api-routes';
import type { CurrentClientUserApiData } from '@client/entity/current-client-user/data/api-data/current-client-user.api-data';
import { CockpitApiService } from '@shared/common/host/data/service/cockpit.api-service';

@injectable()
@injectFromBase()
export class CurrentClientUserApiService extends CockpitApiService {
  public getCurrentClientUser(): Promise<AxiosResponse<CurrentClientUserApiData>> {
    return this.get<CurrentClientUserApiData>(CurrentClientUserApiRoute.Me);
  }
}
